// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BeePageEditorController from "./bee_page_editor_controller"
application.register("bee-page-editor", BeePageEditorController)

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import GeosearchController from "./geosearch_controller"
application.register("geosearch", GeosearchController)

import UploaderController from "./uploader_controller"
application.register("uploader", UploaderController)

import FormsController from "./forms_controller"
application.register("forms", FormsController)

import FieldController from "./field_controller"
application.register("field", FieldController)

import ConstructorController from "./constructor_controller"
application.register("constructor", ConstructorController)

import SortingController from "./sorting_controller"
application.register("sorting", SortingController)

import SubmissionController from "./submission_controller"
application.register("submission", SubmissionController)